import RgaDomainValues from '../state/rga-domain-values';
import actions from '../../../actions-list';
import {getDefaultState as getDefaultRgaAnalysisStatus} from '../state/rga-analysis-status';
import {getDefaultState as getDefaultRgaRequesterType} from '../state/rga-requester-type';
import {getDefaultState} from '../state';

const updateRgaStatus = (state, action) => RgaDomainValues.update(state, {
    rgaRecallStatus: {
        currentStatus: {
            $set: action.rgaRecallStatus.currentStatus
        },
        genericStatus: {
            $set: action.rgaRecallStatus.genericStatus
        },
        infoReqStatus: {
            $set: action.rgaRecallStatus.infoReqStatus
        },
        partReqStatus: {
            $set: action.rgaRecallStatus.partReqStatus
        },
        photoReqStatus: {
            $set: action.rgaRecallStatus.photoReqStatus
        }
    }
});

/**
 * Updates the RGA units in the state with the provided action.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The action containing the RGA units to update.
 * @param {Array} action.rgaUnits - The array of RGA units to update.
 * @param {string} action.rgaUnits[].respUnitCode - The code of the RGA unit.
 * @param {string} action.rgaUnits[].respUnitValue - The value of the RGA unit.
 * @returns {Object} The updated state with the new RGA units.
 */

const updateRgaUnits = (state, action) => {

    const keyValuePairs = action.rgaUnits.map(unit => ({
        key: unit.respUnitCode,
        value: unit.respUnitValue
    }));

    return RgaDomainValues.update(state, {
        rgaUnits: {
            $set: keyValuePairs
        }
    });

};

const updateRgaRequestorType = state =>

     RgaDomainValues.update(state, {
         requesterType: {
             $set: getDefaultRgaRequesterType()
         }
     });

const updateRgaAnalysisStatus = state =>

     RgaDomainValues.update(state, {
         analysisStatus: {
             $set: getDefaultRgaAnalysisStatus()
         }
     });

export default (state = getDefaultState().rgaDomainValues, action) => {

    const actionTypes = {

        [actions.UPDATE_RGA_STATUS_DROPDOWN]: updateRgaStatus,
        [actions.UPDATE_RGA_UNIT_DROPDOWN]: updateRgaUnits,
        [actions.UPDATE_RGA_REQUESTOR_TYPE_DROPDOWN]: updateRgaRequestorType,
        [actions.UPDATE_RGA_ANALYSIS_STATUS_DROPDOWN]: updateRgaAnalysisStatus

    };

    const reducer = actionTypes[action.type];

    return reducer ? reducer(state, action) : state;

};



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/reducers/rga-domain-values.js